import React from 'react';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import propTypes from 'prop-types';

export function IntroTextBlock(props) {

    const { heading, copy, links, block, onClickActions } = props;

    function renderButtons() {

        function handleOnClick (link) {
            const onClickAction = _.find(link.dataAttributes, {key:'onClickAction'})
            let onClickFunction = _.noop();
        
            if (onClickAction?.value) {
                onClickFunction = onClickActions[onClickAction.value]
            }

            onClickFunction();
        }

        const markup = _.isEmpty(links) ? null : 
            <div className={`${block}__ctas`}>
                { links.map((link) => 
                    <div className={`${block}__button`} key={`${block}-${link.id}`}>
                        <Button {...{
                            id: `${link.id}`,
                            label : link.label,
                            mobileLabel: link.mobileLabel,
                            gtmLabel : CORE_GTM_TRACKING_VALUES.label[link.id] || '',
                            testId : `${link.id}`,
                            type: link.type.toLowerCase(),
                            cssAnimation: false,
                            onClickCallback : () => {
                                handleOnClick(link)
                            }, 
                        }}/>
                    </div>
                )}
            </div>
        
        return markup
    }

    return (
        <>
            <CssAnimation
                enter={{
                    name: 'short-slide-up-fade-in',
                    delay: '0.5, hidden',
                    duration: 1
                }}
                triggerEnter={'in-view-init'}
            >
                <section className={`${block}__content-grid container-xl`}>
                    <header className={`${block}__header`}>
                        <h2 className={`${block}__heading`}>
                            {heading}
                        </h2>
                    </header>
                    <div>
                        <div className={`${block}__grid__content`}>
                            <p>{copy}</p>
                            {renderButtons()}
                        </div>
                    </div>
                </section>
            </CssAnimation>
        </>
    )
}

IntroTextBlock.propTypes = {
    heading:propTypes.string, 
    copy:propTypes.string, 
    block:propTypes.string,
    links:propTypes.array, 
    onClickActions:propTypes.object, 
};

IntroTextBlock.defaultProps = {
    heading: 'heading', 
    copy: 'copy', 
    block: 'c-intro-text-block',
};